export default __webpack_public_path__ + "media/banner_VN.92c8b276.png";